export default __webpack_public_path__ + "copy-token.7c1ff19d.png";